import { can, type Perm } from '@rs/policy/grants'
import { useRoleOptional } from '../app/auth.tsx'

/**
 * ══ NÚT THEO QUYỀN TRÊN MÀN 🔐 PHÂN QUYỀN (D03c Đợt 5) ══
 * `useCan()('purchaseDocs.invoices', 'export')` — vai đang đăng nhập còn quyền đó ở mục đó không. Dùng để ẨN BỚT nút: luôn
 * GỘP với điều kiện vai đang có của nút (`&&`), không thay thế — mặc định Sửa/Thêm/Xuất theo Xem nên hôm nay không nút nào đổi.
 * Ngoài `<AuthProvider>` (ca kiểm) ⇒ luôn đúng, như `useScreenTab`.
 */
export const useCan = (): ((node: string, perm: Perm) => boolean) => {
  const role = useRoleOptional()
  return (node, perm) => role === null || can(role, node, perm)
}
